module.exports = __webpack_public_path__ + "img/tech_image_2_5.aa1b06ef.jpg";